import {AppError} from '../../core/AppError';

class SessionStorage {
    check() {
        if (!window.sessionStorage) {
            throw new AppError('Объект sessionStorage не поддерживается данным браузером. '
                + 'Пожалуйста, воспользуйтесь другим Internet-браузером.');
        }
    }

    get(fieldName) {
        return sessionStorage.getItem(fieldName);
    }

    set(fieldName, value) {
        sessionStorage.setItem(fieldName, value);
    }

    remove(fieldName) {
        sessionStorage.removeItem(fieldName);
    }
}

export default SessionStorage;
